<be-dialog-shell title="Avisos de CNC Dental" [closeButton]="false">
    <div class="lista">
        <app-comunicado-detalle *ngFor="let c of data.comunicados" [comunicado]="c" [conEnlaceConsulta]="false"></app-comunicado-detalle>
    </div>
    <dialog-actions>
        <button mat-button type="button" *ngIf="fallo" (click)="cerrarSinMarcar()">Cerrar</button>
        <button mat-flat-button color="primary" type="button" (click)="entendido()" [disabled]="enviando">Entendido</button>
    </dialog-actions>
</be-dialog-shell>
